import { Tab, TabContent, TabList, TabPanel, Tabs } from '@angular/aria/tabs';
import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, contentChildren, input, model } from '@angular/core';
import { TabComponent } from './tab/tab.component';
import { TabsAppearance } from './tabs.type';

@Component({
  selector: 'app-tabs',
  imports: [TabList, Tab, TabPanel, TabContent, NgTemplateOutlet],
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss',
  hostDirectives: [Tabs],
  host: {
    '[class.underline]': "appearance() === 'underline'",
  },
})
export class TabsComponent<V extends string = string> {
  selectedTab = model<V>();

  appearance = input<TabsAppearance>('segmented');

  ariaLabel = input<string | null>(null);

  protected tabs = contentChildren<TabComponent<V>>(TabComponent);

  protected activeTab = computed(
    () =>
      this.selectedTab() ??
      this.tabs()
        .find((tab) => !tab.disabled())
        ?.value(),
  );

  protected select(value: string | undefined) {
    const tab = this.tabs().find((item) => item.value() === value);

    if (tab) this.selectedTab.set(tab.value());
  }
}
